import { Component } from '@angular/core';

@Component({
  selector: 'app-blog-190831',
  templateUrl: './blog-190831.component.html'
})
export class Blog190831Component { }
